import clientfeathers from './feathers';

export const serverFindData = (service, query) => () => {
    
    return clientfeathers.service(service).find(query).then(
        data => {
            return data;
        }
    ).catch( 
        error => {
            return {
                total : 0,
                data : []
            };
        }
    )
}

export const serverGetAllData = (service) => () => {
    
    return clientfeathers.service(service).find().then(
        data => {
            return data;
        }
    ).catch( 
        error => {
            return {
                total : 0,
                data : []
            };
        }
    )
}

